<template>

	<div id="home">
		<addressBar
			:isBack = "false"
			:goBackLink = "'/'"
      class="fixed"
		/>

    <div class="home-header"></div>
    <div class="banner-group ">
      <img src="~assets/icon/bannerPlaceHolder.png" class="banner-slide" v-if="bannerDatas.length === 0"/>
      <mt-swipe :auto="3000"  v-if="bannerDatas.length !== 0">

        <mt-swipe-item class="banner-slide" v-for="(banner,index) in bannerDatas" :key="index">
          <img :src="banner.src + '?imageView2/0/w/690/h/740'" alt="" @click="goBannerEvent(banner)">
        </mt-swipe-item>
      </mt-swipe>
    </div>

    <div class="home-content">
      <div v-for="(parentCategoryGoodsVo,kIndex) in datas"  :key="kIndex">

        <div class="home-content-cellHeader">
          <span class="home-content-typeName">{{parentCategoryGoodsVo.name}}</span>
          <span>
            <span @click="goClassify(parentCategoryGoodsVo.id)" class="home-content-rightText">查看全部</span>
            <span class="icon-arrow-right home-content-right "></span>
          </span>
        </div>
        <hr style="height: 1px;background-color: #cccccc;" class="home-content-cellHeaderHr"/>

        <div class="home-content-cellContent">

          <span v-for="(product,pIndex) in parentCategoryGoodsVo.homePageGoodsVos" class="home-content-cell" :key="pIndex"  >
            <!--<router-link :to="'/productdetail/' + product.productId">  goProductEvent(product.productId)-->
            <v-touch v-on:tap="goProductEvent(product.goodsChannelId)">
              <img v-lazy="product.imgUrl + '?imageView2/0/w/450'" class="home-content-cellImg" v-if="!!product.imgUrl"/>
              <img src="../../../assets/images/default-pro-small.png" class="home-content-cellImg" v-else/>
              <div class="home-content-cellNameText"><a style="overflow:hidden;text-overflow: ellipsis;" class="home-content-cellNameText">{{product.displayName}}</a> </div>
              <div class="home-content-cellPriceText">¥{{product.discountPrice/100}}</div>
            </v-touch>

            <!--</router-link>-->
          </span>

        </div>

      </div>
    </div>

    <div class="home-footer" style="height: 60px"></div>

	</div>

  
</template>
<script>

  import mapHelper from '@/js/mapHelper'
  import payHelper from '@/js/payHelper'
  import api from '@/api/common/api.common'
  import http from '@/api/api.js'
  import homeApi from '@/api/home/api.home'
  import bus from '../../../js/eventBus'
	import addressBar from '@/components/common/navbar/adressBar'
  import { MessageBox } from '@/js/mint-ui'

  	export default {
	    name: 'homeIndex',
	    props: [],
	    data () {
	      return {
          bTrue: true,
          typeNames: ['','蛋糕','下午茶','手信'],
          datas: '',
          cityData: undefined,
          localPosition: undefined,
          bannerDatas: [],
          productType: undefined,
          bannerImg: require('../../../assets/icon/bannerPlaceHolder.png')
	      }
	    },
	    components: {
	    	addressBar,
	    },
	    methods: {
        warn (event) {
          alert(event.type)
        },
        goProductEvent (id) {
          this.$router.push('/productdetail/' + id)
        },
	      getProductType ( self ) {

          api.getProductType({},function (respond) {
            console.log('respond',respond);
            var types = respond.body.data
            var productType = {}
            types.forEach(function (type) {
              productType[type.type] = type.id
            })
            self.productType = productType
          })
        },
        goBannerEvent (banner) {
	        if (banner['url'] !==undefined && banner.url !== 'http://' && banner.url !== '') {
	          if (banner.url.indexOf('https://') === -1 && banner.url.indexOf('http://') === -1) {
              window.location.href = 'http://' + banner.url
            } else {
              window.location.href = banner.url
            }

          }
        },
	      getAllData ( self ) {
          var self = this
          // 获取所有城市
          this.getCityData( self )
          // 查看全部的蛋糕类型
          this.getProductType( self )
	        // 获取轮播图
	        this.getBannerData( self )
          // 获取蛋糕list
          this.getCakeList( self )
          // 获取是否截单
          // 
          const localCityId = localStorage.getItem('locationCity') ? JSON.parse(localStorage.getItem('locationCity')).regionId : undefined;
          localCityId&&homeApi.getCityClosing({
            cityId: localCityId,
            channel: 3
          },function (res) {
            const data = res.body.data;
            const { isPageShow } = data;
            if( isPageShow ) {
                MessageBox({
                  title: '温馨提示',
                  message: data.description,
                  showConfirmButton: false
                });
                document.querySelector('.mint-msgbox-wrapper').classList.add("cutOrder");
            }

          },function (respond) {
          },false)
        },
	      getBannerData ( self ) {

	        homeApi.getBanner({},function (respond) {
            self.bannerDatas = respond.body.data
          },function () {

          },false)

        },
	      initData () {
	        var self = this
          var city = {cityId:'440300', regionId:"440300", name:"深圳市", cityName:"深圳市", provinceName: "广东省"}
          var data = {}
          data.regionlismCityId = city.regionId
          api.cacheLocation(data,function (respond) {
//            self.$store.dispatch('setUserCity' , city)
            localStorage.setItem('cacheKey', respond.body.data['cacheKey']);
            bus.$emit('changeCity',city)
            self.getAllData(self)

          })
        },
	      getCakeList (self) {
          homeApi.getHomeCakeList({},function (respond) {
            self.datas = respond.body.data
          })
        },
	      getCityData ( self ) {

          if (this.hasGetLocation()) {
	          this.getCakeList(this)
          } else {
            api.getAllXFCity({},function (respond) {
              self.cityData = respond.body.data
              if (self.localPosition !== undefined) {
                self.autoSelectCity(self)
              }
            })
          }

        },
        cacheCity(city,self){
          var data = {}
          data.regionlismCityId = city.regionalismId
          api.cacheLocation(data,function (respond) {
            console.log(respond)
            self.$store.dispatch('setUserCity' , city)
            localStorage.setItem('cacheKey', respond.body.data['cacheKey'])
            var cityStr = JSON.stringify(city)
            localStorage.setItem('locationCity', cityStr)
            bus.$emit('changeCity',city)
            if (city.cityName !== '深圳市') {
              self.getAllData(self)
            }
          })
        },
	      autoSelectCity (self) {

          var searchCityCount = 0
          var searchCity = undefined
          self.cityData.forEach(function (city) {
            if (city.isCity === 1) {
              if (city.cityName === self.localPosition.city) {
                searchCityCount++
                searchCity = city
              }
            }
          })

          if (searchCityCount === 1) {
            self.cacheCity(searchCity,self)
          } else {
            self.$router.push('/chooseCity')
          }

        },
	      goClassify (key) {
	      	// this.$store.dispatch('getCategory',{id: id});
          var id = key;
	      	this.$router.push({
	      		path: 'productList/parentId/'+id
	      	})
	      },
        getLocalPosition () {
          // 定位
          var self = this
          mapHelper.getCurrentLocation(function (address) {

            self.localPosition = address
            if (self.cityData !== undefined) {
              self.autoSelectCity(self)
            }
          })
        },

        hasGetLocation () {

          if (localStorage.getItem('locationCity') === null) {
            return false
          } else {
            return true
          }
        }
	    },
	    created () {
        // 处理微信登录

	    },
	    computed: {
	      
	    },
	    mounted () {

        if (!this.hasGetLocation()) {
          // 初始化深圳商品
          this.initData()
          // 定位
          this.getLocalPosition()

        } else {
          this.getAllData()
        }
	    }
  	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';

 	.banner-group {

 		height: pxToRem(740px);
    margin-left: pxToRem(30px);
    margin-right: pxToRem(30px);
 		.banner-slide {
      height: pxToRem(740px);
 			img {
 				/*max-width: 100%;*/
        width: 100%;
        height: 100%;
 			}
 		}
 		.mint-swipe-indicator {
 			background-color: rgba(255,255,255,1);
 			opacity: 0.5;
 			transform: scale(.75);
 			&.is-active{
 				background-color: rgba(255,255,255,1);
 				opacity: 1;
 				transform: scale(1);
 			}
 		}
 	}

  .home-content-cellHeader {
    height: pxToRem(74px);
    margin-top: pxToRem(80px);
    margin-left: pxToRem(30px);
    margin-right: pxToRem(30px);


    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .home-content-cellHeaderHr {
    margin-left: pxToRem(30px);
    margin-right: pxToRem(30px);
    margin-bottom: pxToRem(40px);
  }

  .home-content-cellContent {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: pxToRem(46px);
    margin-right: pxToRem(6px);
  }

  .home-content-cell {
    width: pxToRem(300px);
    height: pxToRem(416px);
    margin-right: pxToRem(40px);
    /*margin-left: pxToRem(28px);*/
    margin-bottom: pxToRem(60px);
  }
  .home-content-cellImg {
    width: pxToRem(300px);
    height: pxToRem(300px);
    background-color: white;
  }
  .home-content-cellNameText {
    margin-top: pxToRem(40px);
    font-size: pxToRem(24px);
    /*height: pxToRem(26px);*/
    text-align: center;
    color: black;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space:nowrap;
    width: pxToRem(300px);
  }
  .home-content-cellPriceText {
    font-size: pxToRem(24px);
    margin-top: pxToRem(4px);
    text-align: center;
    color: #d8331d;
  }
  .home-content-right {
    vertical-align: -4%;
  }
  .home-content-rightText {
    color: #BDBDBD;
    font-size: pxToRem(24px);
    margin-right: pxToRem(10px);
  }
  .home-content-typeName {
    color: #191919;
    font-size: pxToRem(28px);
  }

  .home-header {
    height: pxToRem(100px);
    background-color: transparent;
  }
	
  .cutOrder {
    .mint-msgbox {
      background-color: #492c23;
      .mint-msgbox-header {
        padding-top: pxToRem(55px);
      }
      .mint-msgbox-title,.mint-msgbox-message {
        color: #fff;
        line-height: 1.5em;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// home.vue?cb735b1a